import { Intent } from "@blueprintjs/core"
import CloseButton from "components/Molecules/CloseButton"
import React, { ComponentProps } from "react"
import classNames from "utils/classNames"
import clsx from "utils/clsx"
import styles from "./styles.module.scss"
type NoteProps = ComponentProps<"div"> & {
  children?: React.ReactNode
  intent?: Intent
  onClear?: () => void
  textClassName?: any
  decolorize?: boolean
}
const Note = ({
  children,
  intent = "primary",
  className,
  onClear,
  textClassName,
  decolorize = false,
  ...props
}: NoteProps) => {
  return (
    <div
      className={classNames(
        styles.base,
        styles[intent],
        decolorize && styles["decolorize"],
        className
      )}
      {...props}
    >
      <div className={clsx("m-0", textClassName)}>{children}</div>
      {onClear && <CloseButton intent={intent} onClick={onClear} />}
    </div>
  )
}

export default Note
